/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1753
 */

"use strict"

var r = require(/* 257 */"../1754/257/index")
var o = require(/* 1084 */"./1084")
var /* [auto-meaningful-name] */r$aTypedArray = r.aTypedArray;
(0, r.exportTypedArrayMethod)("fill", function (e) {
  return o.apply(r$aTypedArray(this), arguments)
})
